module.exports = __webpack_public_path__ + "static/Gibson-Light-webfont-a127d7f3e0bad62b14ba007cb223090e.woff";